/* eslint-disable import/prefer-default-export */
export const ADD_PAYOUT_METHOD_ON_SUCCESS = 'ADD_PAYOUT_METHOD_ON_SUCCESS'
